// itg js


// if($('.product-single__video video').length){
// setInterval(videoPlay,100);
// }
// function videoPlay() {
//   if($('.product-single__video').hasClass('slick-current')){
//     $('.product-single__video.slick-slide[aria-hidden="true"] video').trigger('pause');
//     $('.product-single__video.slick-slide.slick-current.slick-active video').trigger('play');
//   }else{
//     $('.product-single__video.slick-slide video').trigger('pause');
//   }
// }

// if($('.product-single__media iframe').length){
// setInterval(iframePlay,100);
// }

// function iframePlay() {
//   if($('.product-single__media').hasClass('slick-current')){
//     var hiddenIframe = $('.product-single__media[aria-hidden="true"] iframe');
//     for (let i = 0; i < hiddenIframe.length; i++){
//       $('.product-single__media[aria-hidden="true"] iframe')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//     }
//     $('.product-single__media.slick-slide.slick-current.slick-active iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
//   }else{
//     var iframe = $('.product-single__media iframe');
//     for (let i = 0; i < iframe.length; i++){
//      $('.product-single__media iframe')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//    }
//   }
// }


$('.js_prod_detail,.js_prod_main,.js_prod_main2').on('afterChange', function(event, slick, currentSlide, nextSlide){
  
  if($('.product-single__video').hasClass('slick-current')){
    $('.product-single__video.slick-slide[aria-hidden="true"] video').trigger('pause');
    $('.product-single__video.slick-slide.slick-current.slick-active video').trigger('play');
  }else{
    $('.product-single__video.slick-slide video').trigger('pause');
  }
  
  if($('.product-single__media').hasClass('slick-current')){
    var hiddenIframe = $('.product-single__media[aria-hidden="true"] iframe');
    for (let i = 0; i < hiddenIframe.length; i++){
      $('.product-single__media[aria-hidden="true"] iframe')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    }
    $('.product-single__media.slick-slide.slick-current.slick-active iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  }else{
    var iframe = $('.product-single__media iframe');
    for (let i = 0; i < iframe.length; i++){
     $('.product-single__media iframe')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
   }
  }
  
});